// Module
var code = `<template>
  <require from="./current-date-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .current-date-widget-\${id} {
      font-family: \${font};
      font-size: \${fontSize}px;
      color: \${color | widgetTemplateColor:isInDashboard} !important;
      text-align: \${textAlign || 'left'};
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="current-date-widget current-date-widget-\${id}">\${date | date:'dd.MM.yyyy'}</div>
</template>
`;
// Exports
export default code;